import React, { useCallback } from 'react';
import { FilePdfIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { photoUrlBase } from 'constants/common';
import { GAClickButton } from 'utils/analytics';
import { selectPageModelTitle } from 'store/pageModel';
import { Manual, ManualLinkStyles, StyledLink } from './styles';

export const AnalizVodyManual = () => {
	const title = useSelector(selectPageModelTitle);

	const clickHandler = useCallback(() => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: title,
			elementText: 'Инструкция по подготовке воды для анализа',
		});
	}, [title]);

	return (
		<Manual data-qa="analiz-vody-manual">
			<FilePdfIcon type="outline" size="l" color="text-primary" />
			<Typography variant="m" size="body_accent">
				Ознакомьтесь с{' '}
				<StyledLink
					href={`${photoUrlBase}/qxaBq8X3A0WYle-xY_-rIg/services-platform-analiz-vody-manual.pdf`}
					target="_blank"
					className={ManualLinkStyles}
					onClick={clickHandler}
				>
					инструкцией по подготовке воды для анализа
				</StyledLink>
			</Typography>
		</Manual>
	);
};
